import { useSelector } from 'react-redux';
import { useSuspenseQuery } from '@tanstack/react-query';
import { API } from 'api';

import { SECTIONS, DOMAINS, IMPORTANCE, INTEGRATIONS } from '@repo/monitoring';

import { apiName, apiBasePath } from 'assets';
import { getMainAccountId } from 'store/account';
import { Consult } from 'types/Consult';

export async function getConsults(mainAccountId: string) {
  const response = await API.get(
    apiName,
    `${apiBasePath}/consults`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.CONSULTS,
        domain: DOMAINS.CONSULTS,
        importance: IMPORTANCE.HIGH,
        integration: INTEGRATIONS.CALENDLY,
      },
      context: {
        mainAccountId,
      },
    },
  );
  return response;
}
export const getConsultsQuery = (mainAccountId: string | null) => ({
  queryKey: [apiName, `consultsList`, mainAccountId],
  queryFn: async () =>
    (mainAccountId && (await getConsults(mainAccountId))) ?? [],
});

const useConsults = () => {
  const mainAccountId = useSelector(getMainAccountId);

  const consultsListQuery = useSuspenseQuery<Consult[]>({
    queryKey: [apiName, `consultsList`, mainAccountId],
    queryFn: () => (mainAccountId ? getConsults(mainAccountId) : []),
  });

  return consultsListQuery;
};

export default useConsults;
